<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    {{ $route.meta.title }}
                    <el-button class="title_btn" @click="moveCreate()" type="primary">등록</el-button>
                </div>
                <div class="list-content content tab-content">
                    <div
                        class="intro_tab col_2"
                        @click="moveLiveClass()"
                        :class="{ active: tab === 'liveClass' }"
                    >
                    Real Class 관리
                    </div>
                    <div
                        class="intro_tab col_2"
                        :class="{ active: tab === 'class' }"
                    >
                        Class 수익 내역
                    </div>
                </div>
                <div v-if="tab === 'class'" class="list-content">
                    <live-klass-list-component :liveklassType="`adjust`" :tab="tab"></live-klass-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>

import LiveKlassListComponent from "@/components/liveklass/LiveKlassListComponent";
import util from "@/mixins/util";

export default {
    name: "LiveKlassAdsjust",
    mixins: [],
    components: {LiveKlassListComponent},
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
            tab: "class",
        };
    },
    created() {
        if (!util.isEmpty(this.$route.query.tab)) {
            this.tab = this.$route.query.tab;
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        moveCreate() {
            this.$router.push('/content/liveklass/create');
        },
        moveLiveClass() {
            this.$router.push('/content/liveklass');
        },
    },
    watch: {
        "$route.path": {
            deep: true,
            handler: function (val, oldVal) {
                console.log(!util.isEmpty(this.$route.query.tab))
                console.log(this.tab !== this.$route.query.tab);
                console.log(this.$route.query)
                if (
                    !util.isEmpty(this.$route.query.tab) &&
                    this.tab !== this.$route.query.tab
                ) {
                    this.changeTab(this.$route.query.tab);
                }
            },
        },
    },
};
</script>
